module.exports = __webpack_public_path__ + "media/Diamante.6c37440c.mp3";